const siteConfig = {
  siteName: 'OncoLysis Admin',
  siteIcon: 'ion-user',
};
const themeConfig = {
  topbar: 'themedefault',
  sidebar: 'themedefault',
  layout: 'themedefault',
  theme: 'themedefault',
};
const language = 'english';
export {
  siteConfig,
  language,
  themeConfig
};
